<template>
  <div grid-list-xl class="pa-0 ma-0">
    <v-card
      v-show="!startLesson"
      min-height="170px"
      class="rounded-card elevation-0 pa-3 ma-3"
    >
      <div style="font-size: 27px; font-weight: bold; color: #415370">
        <span>&nbsp;</span>
        <h1>{{ primerintro.pageTitle }} Contents</h1>
      </div>

      <v-flex sm12 md10 my-5 mx-2>
        <p>{{ primerintro.textArea }}</p>
        <v-btn large round outline color="primary" @click="$router.go(-1)">
          Back
        </v-btn>
        <v-btn large round outline color="primary" @click="goToSlide(0)">
          Start
        </v-btn>
      </v-flex
      >
      <v-divider></v-divider>
      <v-card-actions>
        <v-card-text style="color: #415370; font-weight: bold;">
          <ol style="padding: 0px; !important">
          <div v-for="(slide, i) in flamelinkdata" :key="i">
              <v-btn
                flat
                v-if="slide.pageTitle && slide.linked == true"
                @click="goToSlide(i)"
                class="body-2 toc-button"
              >
              <div v-if="isSubtitle(slide)">
                <ul>
                  <li> {{ slide.pageTitle }} </li>
                </ul>
              </div>
              <div v-else>
                <li style="list-style: inherit;"> {{ slide.pageTitle }}</li>
              </div>
              </v-btn>
          </div>
          </ol>
        </v-card-text>
      </v-card-actions>
    </v-card>
    <div id="root">
      <step-wizard
        ref="stepref"
        v-show="startLesson"
        :slideContent="flamelinkdata"
      >
      </step-wizard>
    </div>
  </div>
</template>

<script>
import StepWizard from "./StepWizard.vue";

function collectImages(slide){
  var result;
switch (slide.displayMode) {
  case "imageDeck":
    result = slide.imageDeck
    break;
    case "richText":
    result = slide.textRepeat
    break;
    case "both":
    result = slide.imageDeck.concat(slide.textRepeat)
    break;
  default:
    result = [];
    break;
}
  return result;
}

export default {
  components: {
    "step-wizard": StepWizard,
  },
  data() {
    return {
      startLesson: false,
      flamelinkdata: [],
      primerintro: [],
      tableIndex: 0,
    };
  },
  created() {
    this.flamelinkdata = this.$store.state.primerData.filter(
      (x) => x.primerPart === this.$route.params.part
    );
    this.flamelinkdata = _.orderBy(this.flamelinkdata, "order", "asc");
    for (var i = 0; i < this.flamelinkdata.length; i++) {
      this.flamelinkdata[i].img = this.findImages(i);
      this.flamelinkdata[i].caption = this.findCaptions(i);
      this.flamelinkdata[i].richText = this.flamelinkdata[i].textRepeat ? this.flamelinkdata[i].textRepeat : null;
    }
    this.primerintro = this.flamelinkdata.shift();
  },
  methods: {
    findImages(currentActive) {
      // this function pushes all the images to the store and saves images per slide in slidecontent.img
      var slideImages = [];
      var imagesSource =  collectImages(this.flamelinkdata[currentActive])
      if (!imagesSource) return slideImages;
      for (var i = 0; i < imagesSource.length; i++) {
        if (imagesSource[i].image) {
          slideImages.push(
            // for the slide thats currently active, push all images
            this.$store.getters.image(imagesSource[i].image[0])
          );
          if (slideImages[i].file)
            this.$store.dispatch("getPrimerImage", slideImages[i].file);
        }
      }
      return slideImages;
    },
    findCaptions(currentActive) {
      var slideCaptions = [];
      if (!this.flamelinkdata[currentActive].imageDeck) return;
      for (
        var i = 0;
        i < this.flamelinkdata[currentActive].imageDeck.length;
        i++
      ) {
        slideCaptions.push(
          // for the slide thats currently active, push all captions
          this.flamelinkdata[currentActive].imageDeck[i].description
        );
      }
      return slideCaptions;
    },
    preloadImage(url) {
      // WIP
      var img = new Image();
      img.src = url;
    },
    goToSlide(slideNum) {
      this.startLesson = true;
      this.$refs.stepref.changeTab(slideNum);
    },
    isSubtitle(title){
      for (var n = 0; n < this.flamelinkdata.length; n++){
        if(title.parentId == this.flamelinkdata[n].id){
          return true
        }
      }
      return false
    }
  },
};
</script>
<style scoped>
.rounded-card {
  border-radius: 10px;
}
p {
  font-size: 16pt;
}
/* .toc-button {
  padding-left: 32px;
} */
</style>
